import React from 'react';

const Gambling = () => {
  return <div>Gambling</div>;
};

export default Gambling;
